import React from "react";
import { Card, Row, Col, Badge, ProgressBar } from "react-bootstrap";
import {
  FiUser,
  FiRepeat,
  FiStar,
  FiClock,
  FiMessageSquare,
} from "react-icons/fi";
import MainCard from "../../../Components/Cards/MainCard";

const AgentProfileScoreCard = ({ profile }) => {
  const getProgressBarVariant = (value) => {
    if (value >= 80) return "primary";
    if (value >= 60) return "info";
    return "warning";
  };

  return (
    <MainCard>
      <div className="p-3">
        {/* --- Header Section (Name and Monthly Earnings) --- */}
        <Row className="align-items-start mb-3 text-center gap-2 gap-sm-0 text-sm-start">
          <Col xs={12} sm={8}>
            <div className="d-flex align-items-center justify-content-center justify-content-sm-start">
              <div className="bg-light p-1 rounded me-2">
                <img
                  src={profile.imageUrl}
                  alt={profile.name}
                  className="rounded-circle"
                  width="50"
                  height="50"
                />
              </div>
              <div>
                <h5 className="mb-0 fw-bold">{profile.name}</h5>
                {profile.isTopPerformer && (
                  <Badge
                    bg="success-subtle"
                    className="mt-1 text-success bg-opacity-10 rounded-pill"
                    style={{ fontSize: "0.75rem" }}
                  >
                    top performer
                  </Badge>
                )}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={4} className="text-center text-sm-end">
            <h4 className="mb-0 text-success fw-bold">
              {profile.monthlyEarnings}
            </h4>
            <small className="text-muted">Monthly</small>
          </Col>
        </Row>

        {/* --- Rebook Rate & Avg Rating Metrics --- */}
        <Row className="mb-3 gx-4">
          {/* Rebook Rate */}
          <Col xs={12} sm={6} className="mb-3 mb-sm-0">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <div className="d-flex align-items-center small me-2">
                <FiRepeat size={14} className="me-1 text-muted" />
                <small className="text-muted text-nowrap">Rebook Rate</small>
              </div>
              <span className="fw-bold text-nowrap">{profile.rebookRate}%</span>
            </div>
            <ProgressBar
              now={profile.rebookRate}
              variant={getProgressBarVariant(profile.rebookRate)}
              style={{ height: "6px", borderRadius: "3px" }}
            />
          </Col>

          {/* Avg Rating */}
          <Col xs={12} sm={6}>
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <div className="d-flex align-items-center small me-2">
                <FiStar size={14} className="me-1 text-muted" />
                <small className="text-muted text-nowrap">Avg Rating</small>
              </div>
              <span className="fw-bold text-nowrap">{profile.avgRating}/5</span>
            </div>
            <ProgressBar
              now={(profile.avgRating / 5) * 100}
              variant={getProgressBarVariant((profile.avgRating / 5) * 100)}
              style={{ height: "6px", borderRadius: "3px" }}
            />
          </Col>
        </Row>

        {/* --- Response Time & Reviews --- */}
        <Row className="gx-4 mt-4 gap-2 gap-sm-0">
          {/* Response Time */}
          <Col
            xs={12}
            sm={6}
            className="d-flex align-items-center justify-content-between"
          >
            <div className="d-flex align-items-center small">
              <FiClock size={16} className="me-1 text-muted" />
              <small className="text-muted">Response Time</small>
            </div>
            <h5 className="ms-3 mt-1 mb-0 fw-bold small">
              {profile.responseTime}
            </h5>
          </Col>

          {/* Reviews */}
          <Col
            xs={12}
            sm={6}
            className="d-flex align-items-center justify-content-between"
          >
            <div className="d-flex align-items-center small">
              <FiMessageSquare size={16} className="me-1 text-muted" />
              <small className="text-muted">Reviews</small>
            </div>
            <h5 className="ms-3 mt-1 mb-0 fw-bold small">{profile.reviews}</h5>
          </Col>
        </Row>
      </div>
    </MainCard>
  );
};

export default AgentProfileScoreCard;
